module.exports = __webpack_public_path__ + "media/images/hortense-for-wedding/Groupe 68-814ff66d1b66b10592b8597cdedc2235.png";